var React = require('react');

function SliderArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M35.1429 50.9107V45.8884C35.1429 45.5469 34.9755 45.2254 34.7009 45.0246L8.4777 26L34.7009 6.97545C34.9755 6.77455 35.1429 6.45312 35.1429 6.11161V1.08928C35.1429 0.654017 34.6473 0.399552 34.2924 0.654017L1.7411 24.2656C0.562523 25.1228 0.562523 26.8772 1.7411 27.7277L34.2924 51.3393C34.6473 51.6005 35.1429 51.346 35.1429 50.9107Z"}));
}

SliderArrowInline.defaultProps = {"width":"36","height":"52","viewBox":"0 0 36 52"};

module.exports = SliderArrowInline;

SliderArrowInline.default = SliderArrowInline;
